import { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import Drawer, { DrawerHeader, DrawerFooter } from 'common/components/drawer';
import { FormDrawer } from 'common/components/drawer';
import { useForm, useActions } from 'utils/hooks';
import * as agentTypes from 'store/agent-types/actions';
import { FormBody } from 'common/components/drawer';
import selectDataFromState from 'utils/selectDataFromState';
import EditVisibilityForm from 'components/drawers/EditCompanyVisibility';

import config from './agent-type/config';
import CrewEvaluationTemplateTypes from './agent-type';

const EditAgentType = ({ drawer, active, editType, refetchData }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [updateAgentTypes, createAgentTypes] = useActions([
    agentTypes.updateAgentTypes,
    agentTypes.createAgentTypes
  ]);
  const { formState, loadValues, handleSubmitError, resetForm, collectValues } = useForm(config);
  const { isOpen } = drawer;

  useEffect(() => {
    if (active && isOpen) {
      const params = {
        ...active
      };

      const initialValues = selectDataFromState(params, config);

      loadValues({ ...initialValues });
    }

    if (!isOpen) {
      resetForm();
    }
  }, [isOpen]);

  const submit = async () => {
    const values = collectValues();
    if (!values) return;

    const { ...rest } = values;

    const params = {
      ...rest,
      id: active ? active.id : undefined,
      table: 'agent_types'
    };

    setIsSubmitting(true);

    try {
      if (active) {
        await updateAgentTypes(params);
      } else {
        await createAgentTypes(params);
        resetForm();
        refetchData();
      }

      drawer.close();
    } catch (error) {
      handleSubmitError(error);
    }

    setIsSubmitting(false);
  };

  return active && editType === 'visibility' ? (
    <EditVisibilityForm
      drawer={drawer}
      active={active}
      isOpen={drawer.isOpen}
      type="enums/agent-types"
    />
  ) : (
    <Drawer {...drawer} className="table-drawer">
      <DrawerHeader className="border-bottom pb-4">
        {active ? 'Edit ' + active.name : 'Add New Agent Type'}
      </DrawerHeader>

      <FormDrawer>
        <FormBody>
          <CrewEvaluationTemplateTypes formState={formState} />
        </FormBody>
      </FormDrawer>

      <DrawerFooter className="d-flex justify-content-end p-3">
        <Button
          color="cancel"
          className="px-0 py-1 me-4"
          onClick={() => drawer.close()}
          disabled={isSubmitting}
        >
          CANCEL
        </Button>
        <Button onClick={submit} disabled={isSubmitting} color="primary" className="px-4">
          SAVE
        </Button>
      </DrawerFooter>
    </Drawer>
  );
};

export default EditAgentType;
